import React, { useRef, useState, useEffect } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  ListGroup,
  Nav,
  Row,
  Tab,
  Modal,
} from "react-bootstrap";
// import Modal from "react-awesome-modal";
import { NavLink, Link, useNavigate } from "react-router-dom";
import calendar from "../../../assets/images/icons/calendar.png";
import dummy_coach1_sqr from "../../../assets/images/icons/user.png";
import "./Calendar.css";
import { Scheduler } from "@aldabil/react-scheduler";
import {
  cancelSession,
  changeProgramSessionStatus,
  changeUserProgramSessionStatus,
  getUserBookedSlots,
} from "../../../utils/api";
import { Rating } from "react-simple-star-rating";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
// import moment from "moment";
import moment from "moment-timezone";

import AgoraComponent from "../../../Front/Pages/agora/livestream";
import { api } from "../../../utils/api/axios";
import { toast } from "react-toastify";
import { useUserContext } from "../../../utils/hooks/UserContext";

const TIME_ZONE = "Asia/Kolkata";

// ../../Pages/agora/livestream
const EVENTS = [
  {
    event_id: 1,
    title: "Event 1",
    start: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
    end: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
    disabled: true,
    admin_id: [1, 2, 3, 4],
  },
  {
    event_id: 2,
    title: "Event 2",
    start: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
    end: new Date(new Date(new Date().setHours(12)).setMinutes(0)),
    admin_id: 2,
    color: "#50b500",
  },
  {
    event_id: 3,
    title: "Event 3",
    start: new Date(new Date(new Date().setHours(11)).setMinutes(0)),
    end: new Date(new Date(new Date().setHours(12)).setMinutes(0)),
    admin_id: 1,
    editable: false,
    deletable: false,
  },
  {
    event_id: 4,
    title: "Event 4",
    start: new Date(
      new Date(new Date(new Date().setHours(9)).setMinutes(30)).setDate(
        new Date().getDate() - 2
      )
    ),
    end: new Date(
      new Date(new Date(new Date().setHours(11)).setMinutes(0)).setDate(
        new Date().getDate() - 2
      )
    ),
    admin_id: 2,
    color: "#900000",
  },
  {
    event_id: 5,
    title: "Event 5",
    start: new Date(
      new Date(new Date(new Date().setHours(10)).setMinutes(30)).setDate(
        new Date().getDate() - 2
      )
    ),
    end: new Date(
      new Date(new Date(new Date().setHours(14)).setMinutes(0)).setDate(
        new Date().getDate() - 2
      )
    ),
    admin_id: 2,
    editable: true,
  },
  {
    event_id: 6,
    title: "Event 6",
    start: new Date(
      new Date(new Date(new Date().setHours(10)).setMinutes(30)).setDate(
        new Date().getDate() - 4
      )
    ),
    end: new Date(new Date(new Date().setHours(14)).setMinutes(0)),
    admin_id: 2,
  },
];

const BookingComponentUpcoming = () => {
  const navigate = useNavigate();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { fetchNotifications, notification, unreadNotification } =
    useUserContext();

  useEffect(() => {
    console.log("notiiiiion");
    fetchNotifications();
  }, []);

  const formatDuration = (totalMinutes) => {
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return [
      days > 0 ? `${days} day${days > 1 ? "s" : ""}` : "",
      hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "",
      minutes > 0 ? `${minutes} min${minutes > 1 ? "s" : ""}` : "",
    ]
      .filter(Boolean) // Remove empty values
      .join(", ");
  };
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [visible, setVisible] = useState(false);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [sessionData, setSessionData] = useState(null);
  console.log(visible, sessionData);
  const [events, setEvents] = useState([
    { date: "2024-08-20", name: "Meeting", time: "10:00 AM" },
    { date: "2024-08-22", name: "Conference", time: "02:00 PM" },
    // Add more events as needed
  ]);
  const [bookedEvents, setBookedEvents] = useState([]);
  const [allBookedEvents, setAllBookedEvents] = useState([]);
  const reviewObj = JSON.parse(
    JSON.stringify({
      reviewFrom: "",
      reviewTo: "",
      rating: "",
      description: "",
      program_id: "",
    })
  );
  const [reviewFeedbackPayload, setReviewFeedbackPayload] = useState(reviewObj);

  const [userTimeZone, setUserTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  // AGORA HOOKS
  const [videoCallSessionId, setVideoCallSessionId] = useState("");
  const [videoCallSessionName, setVideoCallSessionName] = useState("");
  const [videoCall, setVideocall] = useState(false);
  const [sessionDetails, setSessionDetails] = useState({});

  const handleSaveReviewFeedback = async () => {
    try {
      const response = await api("reviews", "POST", reviewFeedbackPayload);
      if (response.data.success === true) {
        setShowFeedbackModal(false);
        setReviewFeedbackPayload(reviewObj);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(`Something went wrong! ${error.message}`);
      }
    }
  };

  async function showSessionInterest(id, name, details) {
    const payload = {
      session_status: "live",
      id,
    };
    await changeUserProgramSessionStatus(payload);
    console.log("function called");
    setVideoCallSessionId(id);
    setVideoCallSessionName(name);
    setSessionDetails(details);
    setVideocall(true);
  }

  const getListData = async () => {
    try {
      const data = await getUserBookedSlots();
      console.log(data.data.data, "data");
      setBookedEvents(data.data.data);
      setAllBookedEvents(data.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getListData();
  }, []);

  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTimeLeft = bookedEvents.reduce((acc, item) => {
        // Parse start_time as UTC and convert to user's timezone
        const adjustedTime = moment.utc(item.start_time).tz(userTimeZone);

        // Get current time in user's timezone
        const now = moment().tz(userTimeZone);

        // console.log(adjustedTime.format(), now.format(), "Adjusted vs Now");

        // Calculate the difference
        const durationInMilliseconds = adjustedTime.diff(now);
        const duration = moment.duration(durationInMilliseconds);

        // Calculate cumulative hours and minutes
        const totalHours = Math.floor(duration.asHours());
        // console.log("durations", duration, totalHours);

        // Total hours (including days)
        const hours = totalHours % 24; // Remaining hours
        const minutes = Math.floor(duration.asMinutes() % 60); // Remaining minutes

        acc[item.id] = {
          days: Math.floor(totalHours / 24), // Whole days
          hours: Math.max(0, hours), // Remaining hours
          minutes: Math.max(0, minutes), // Remaining minutes
        };
        return acc;
      }, {});

      setTimeLeft(updatedTimeLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [bookedEvents]);
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  // Filter events between start and end dates
  const filteredEvents = allBookedEvents.filter((event) => {
    const eventDate = new Date(event.date);
    return (
      (!startDate || eventDate >= new Date(startDate)) &&
      (!endDate || eventDate <= new Date(endDate))
    );
  });

  const [searchText, setSearchText] = useState("");

  // 🔍 Filter sessions based on coach_name
  // useEffect(() =>{
  //   setBookedEvents(
  //     allBookedEvents.filter((item) =>
  //       item.coach_name.toLowerCase().includes(searchText.toLowerCase())
  //     )
  //   );
  //   if(searchText == ''){
  //     setBookedEvents(allBookedEvents)
  //   }
  // },[searchText])

  useEffect(() => {
    let filteredEvent = allBookedEvents;
    // Filter by searchText if it's not empty
    if (searchText) {
      filteredEvent = filteredEvent.filter((item) =>
        item.coach_name.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    // Filter by startDate and endDate if both exist
    if (startDate && endDate) {
      filteredEvent = filteredEvent.filter((event) => {
        const eventDate = new Date(event.start_time);
        return (
          eventDate >= new Date(startDate) && eventDate <= new Date(endDate)
        );
      });
    }

    // Update state with filtered events
    setBookedEvents(filteredEvent);
  }, [searchText, startDate, endDate, allBookedEvents]);

  console.log(startDate, endDate);
  const sendData = (item) => {
    console.log("ttttttttt", item);
    if (item) {
      item.coach_program_id = item.program_id;
      item.schedule_type = "Reschedule";
      navigate("/user/schedule-session", { state: { sessionData: item } });
    }
  };

  // const showCancelPopup = (item) =>{
  //   alert("hk")
  //     setSessionData(item);
  //     setVisible(true);
  // }

  const cancelSessions = async () => {
    try {
      console.log(sessionData);
      let data = {
        availability_slot_id: sessionData?.available_slot_id,
        session_slot_id: sessionData?.id,
        program_id: sessionData?.program_id,
        userType: "user",
      };

      const resp = await cancelSession(data);
      console.log("herererer", resp);
      if (resp.status) {
        getListData();
        fetchNotifications();
        toast.success(resp?.message || "session cancelled successfully.");
        setVisible(false);
      } else {
        toast.error("session not cacelled");
      }
    } catch (error) {}
  };
  // Render the table
  const renderTable = () => {
    if (!startDate || !endDate)
      return <p>Select a date range to see events.</p>;

    return (
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Event Name</th>
            <th>Event Time</th>
          </tr>
        </thead>
        <tbody>
          {filteredEvents.map((event, index) => (
            <tr key={index}>
              <td>{event.date}</td>
              <td>{event.name}</td>
              <td>{event.time}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <section className="py-3 coach_my_activity">
      <div>
        <div className="date-selectors d-flex">
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <InputGroup className="mb-3">
              <Form.Control
                type="date"
                value={startDate || ""}
                onChange={handleStartDateChange}
              />
              <InputGroup.Text>to</InputGroup.Text>
              <Form.Control
                type="date"
                value={endDate || ""}
                onChange={handleEndDateChange}
              />
            </InputGroup>
          </Form.Group>
        </div>
      </div>
      <Row className="mb-3 align-items-center">
        <Col xs="4">
          <div className="text-start hdng_a">
            <h2 className="m-0">My Sessions</h2>
          </div>
        </Col>
        <Col>
          <Row className="gx-2 align-items-center">
            <Col>
              <Col lg="12">
                <InputGroup size="sm" className="mb-3">
                  <Form.Control
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <Button>
                    <i className="bi bi-search"></i>
                  </Button>
                </InputGroup>
              </Col>
            </Col>
            {/* <Col>
              <Form.Select>
                <option>Status</option>
              </Form.Select>
            </Col>
            <Col>
              <Form.Select>
                <option>Program Type</option>
              </Form.Select>
            </Col> */}
            {/* <Col xs="auto">
              <div className="d-flex">
                <Button className="pe-0" variant="link">
                  <i className="text_brand_color2 fs-30 bi bi-calendar-week-fill"></i>
                </Button>
                <Button className="pe-0" variant="link">
                  <i className="text_brand_color2 fs-30 bi bi-list-task"></i>
                </Button>
              </div>
            </Col> */}
          </Row>
        </Col>
      </Row>

      <div className="booking-component">
        <ul className="booking_user_list">
          {bookedEvents.length > 0 ? (
            bookedEvents.map((item) => {
              const adjustedTime = moment.utc(item.start_time).tz(userTimeZone);
              const adjustedEndTime = moment
                .utc(item.end_time)
                .tz(userTimeZone);

              const formattedStartTime = adjustedTime.format(
                "MMMM Do YYYY, HH:mm A"
              );
              const formattedEndTime = adjustedEndTime.format(
                "MMMM Do YYYY, HH:mm A"
              );
              // Format start and end times
              // Calculate duration in minutes using moment.utc
              const startTime = moment.utc(
                adjustedTime.format("YYYY-MM-DD HH:mm"),
                "YYYY-MM-DD HH:mm"
              );
              const endTime = moment.utc(
                adjustedEndTime.format("YYYY-MM-DD HH:mm"),
                "YYYY-MM-DD HH:mm"
              );
              const durationInMinutes = endTime.diff(startTime, "minutes");

              // Get remaining time for this session
              const remainingTime = timeLeft[item.id] || {
                days: 0,
                hours: 0,
                minutes: 0,
              };
              const now = moment().tz(userTimeZone);

              const isExpiredTimeRange = moment(adjustedEndTime).isBefore(now);
              // console.log(remainingTime,'93894389');

              return (
                // Add return here
                <li key={item.id}>
                  {" "}
                  {/* Add key prop */}
                  <div className="booking_user_card">
                    <Row className="align-items-center">
                      <Col sm="6">
                        <div className="p-2 booking_user_card_lt">
                          <div className="d-flex align-items-center">
                            <img
                              className="user_img"
                              src={
                                item.coach_profile_pic != null
                                  ? process.env
                                      .REACT_APP_COACH_PROFILE_FOLDER_PATH +
                                    item?.coach_profile_pic
                                  : dummy_coach1_sqr
                              }
                            />
                            <div className="ps-2">
                              {/* <h5>{item?.coach_name}</h5> */}
                              <NavLink
                                to={`/browse-coach/coach-details/${item.coach_id}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                <h5 className="fs-14 fw-500">
                                  {item.coach_name}
                                </h5>
                              </NavLink>
                              <p>
                                {formattedStartTime + " to " + formattedEndTime}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col sm="6">
                        <div
                          className="p-2 booking_user_card_rt"
                          style={{ background: "#F5F5F5" }}
                        >
                          <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                            <h5>
                              {item.type == "single"
                                ? item?.program_title
                                : item?.session_name}
                            </h5>
                            {item.session_day_status === "completed" ? (
                              <Button variant="start-session" className="">
                                Completed
                              </Button>
                            ) : moment(adjustedTime).format(
                                "YYYY-MM-DD HH:mm:ss"
                              ) < moment().format("YYYY-MM-DD HH:mm:ss") &&
                              !isExpiredTimeRange ? (
                              <Button
                                variant="start-session"
                                className=""
                                // disabled={item.session_day_status !== 'live'}
                                onClick={() => {
                                  if (item.session_day_status === "live") {
                                    showSessionInterest(
                                      item.id,
                                      item.program_title,
                                      item
                                    );
                                  } else {
                                    alert("This session is not live yet.");
                                  }
                                }}
                              >
                                Join Session
                              </Button>
                            ) : isExpiredTimeRange ? (
                              <div className="ml-4">
                                <span className="batch-not-started">
                                  Expired
                                </span>
                                {/* <NavLink to={'/user/schedule-session'}> */}
                                <span
                                  variant="success"
                                  className="ml-1 text-center batch-completed"
                                  onClick={() => sendData(item)}
                                >
                                  Reschedule Session
                                </span>
                                {/* </NavLink> */}
                              </div>
                            ) : (
                              <div>
                                <span className="batch-not-started">
                                  Not Started
                                </span>
                                <span
                                  className="bg-red-500 text-white rounded-[5px] p-2 ml-1 cursor-pointer"
                                  onClick={() => {
                                    setSessionData(item);
                                    setVisible(true);
                                  }}
                                >
                                  Cancel Session
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="countdown">
                            {remainingTime.days > 0 && (
                              <span>{remainingTime.days} Days </span>
                            )}
                            {remainingTime.hours > 0 && (
                              <span>{remainingTime.hours} Hours </span>
                            )}
                            {remainingTime.minutes > 0 && (
                              <span>{remainingTime.minutes} Minutes left</span>
                            )}
                          </div>

                          {/* <div className="d-flex justify-content-between align-items-center w-100">
                                    <div className="d-flex align-items-center">
                                        <p className="ms-4">{item.session_name}</p>
                                    </div>
                                   
                                    <span>
                                      Program: {item.type === "single" ? "Single Day" : `${item.no_of_session} Days`} , ${item.price}
                                    </span>

                                    <span>{item.duration} Min</span>
                                </div> */}

                          <div className="program_opted_bg">
                            <div className="d-flex justify-content-end">
                              <small className="fs-12 fw-600">
                                Program:{" "}
                                {item.type === "single"
                                  ? "Single Day"
                                  : `Multi Days`}{" "}
                                , ${item.price}
                              </small>
                            </div>
                            <div className="my-1 d-flex justify-content-between align-items-center">
                              <h5 className="m-0 text_brand_color2 fs-15 fw-600">
                                {item.program_name}
                              </h5>
                              {/* <small className="fs-12 fw-600">Price:${item.price}</small> */}
                              <small className="fs-12 fw-600">
                                {item.type == "single"
                                  ? formatDuration(item.duration)
                                  : formatDuration(item.session_duration)}
                              </small>
                            </div>

                            {item.session_day_status === "completed" && (
                              <div className="d-flex justify-content-end">
                                <Button
                                  variant="start-session"
                                  type="button"
                                  className=""
                                  onClick={() => {
                                    setReviewFeedbackPayload({
                                      ...reviewFeedbackPayload,
                                      reviewFrom: item.user_id,
                                      reviewTo: item.coach_id,
                                      program_id: item.program_id,
                                    });
                                    setShowFeedbackModal(true);
                                  }}
                                >
                                  Review and Feedback
                                </Button>
                                {/* <small className="fs-12 fw-600">{item.duration} Min</small> */}
                                {/* <small className="fs-12 fw-500">Basic Emotional Intelligence</small> */}
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>
              );
            })
          ) : (
            <Col>
              <Lottie
                options={defaultOptions}
                height={300}
                width={400}
                isStopped={false}
                isPaused={false}
              />
            </Col>
          )}
          {videoCall ? (
            <AgoraComponent
              videoCallSessionId={videoCallSessionId}
              videoCallSessionName={videoCallSessionName}
              sessionDetails={sessionDetails}
            />
          ) : (
            ""
          )}
          {/* <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>

          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#964B0033'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>
          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>

          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li> */}
        </ul>
      </div>

      <Container>
        {/* <div>
        <Scheduler
        events={EVENTS}
        disableViewer
        onEventClick={() => {
          console.log("onEventClick");
        }}
      />
      </div> */}
      </Container>
      {/* <Container>
        <div className="booking-component">
          <div className="table-container">
            {renderTable()}
          </div>
        </div>
      </Container> */}

      <Modal
        show={showFeedbackModal}
        onHide={() => {
          setReviewFeedbackPayload(reviewObj);
          setShowFeedbackModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Review and Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="crop-container" style={{ position: "relative" }}>
            <Form.Group className="mt-2 mb-3" controlId="textarea-input">
              <Form.Label>Select Rating</Form.Label>
              <div className="">
                <Rating
                  onClick={(rate) => {
                    setReviewFeedbackPayload({
                      ...reviewFeedbackPayload,
                      rating: rate,
                    });
                  }}
                />
              </div>
            </Form.Group>
            <Form.Group className="mt-2 mb-3" controlId="textarea-input">
              <Form.Label>Write Review</Form.Label>
              <Form.Control
                rows="4"
                name="solution"
                type="text"
                as="textarea"
                onChange={(e) =>
                  setReviewFeedbackPayload({
                    ...reviewFeedbackPayload,
                    description: e.target.value,
                  })
                }
                value={reviewFeedbackPayload.description}
                className="textarea-input"
                placeholder="Write your review here..."
              />
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              setReviewFeedbackPayload(reviewObj);
              setShowFeedbackModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            type="button"
            onClick={handleSaveReviewFeedback}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={visible} onHide={() => setVisible(false)} centered>
        <Modal.Body>
          <div className="text-center">
            <p>
              {" "}
              Are you sure <br />
              You want to cancel this session{" "}
            </p>
            <div className="mt-4 logout_button_container">
              <button
                className="p-2 rounded btn-success me-3"
                onClick={() => {
                  cancelSessions();
                }}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">Yes</h5>{" "}
              </button>
              <button
                className="p-2 text-white border-0 rounded btn-success bg-secondary"
                onClick={() => setVisible(false)}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">No</h5>{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default BookingComponentUpcoming;
